import { Create, SimpleForm, TextInput, BooleanInput, SelectInput, PasswordInput, useNotify, useRefresh, useRedirect } from 'react-admin';
import {useEffect, useState} from "react";
import getDriverTypes from "../../actions/GetDriverTypes";

const UsersCreate = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();
    const [driverTypeList, setDriverTypeList] = useState([{id: '1', name: '2'}]);

    const onSuccess = ({ data }) => {
        notify(`New user ${data.id} has been created`);
        redirect("/users");
        refresh();
    }

    useEffect(() => {
        getDriverTypes(props.adminMode).then((result => {
            setDriverTypeList(result);
        }))
    }, []);


    return (
        <Create {...props} onSuccess={onSuccess}>
            <SimpleForm>
                <TextInput source="username" label="Username"/>
                <PasswordInput source="password" label="Password"/>
                <TextInput source="imei" label="IMEI"/>
                <TextInput source="macAddress" label="MAC"/>
                <SelectInput source="driverType" label="Driver Type" choices={driverTypeList}/>
                <BooleanInput source="isActive" label="Active Status"/>
            </SimpleForm>
        </Create>
    );
}

export default UsersCreate;
